// ----------------------------------------------------------------------
// <copyright file="Izenda.SchedulingSearchConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

const LAST_SUCCESS_RUN_VALUE = {
  DATE: 'date',
  EMPTY: '',
  CANNOT_BE_SEND: 'The report cannot be sent',
  HAS_NOT_STATED: 'The schedule has not started'
};

const DELIVERY_TYPE_VALUE = {
  EMPTY: '',
  EMAIL: 'Email',
  FILE_LOCATION: 'File Location'
};

const DELIVER_METHOD_VALUE = {
  EMPTY: '',
  LINK: 'link',
  ATTACHMENT: 'Attachment',
  EMBEDDED_HTML: 'Embedded HTML',
  SEND_TO_DISK: 'Send to Disk'
};

const RECURRENCE_VALUE = {
  EMPTY: '',
  EVERY_HOURLY: '0',
  EVERY_DAILY: '1',
  EVERY_DAY: '2',
  EVERY_WEEKDAY: '3',
  EVERY_WEEK: '4',
  EVERY_TWO_WEEK: '5',
  EVERY_MONTH: '6',
  EVERY_QUARTER: '7',
  CUSTOM: '8'
};

const REPORT_TYPE_VALUE = {
  Report: 1,
  Dashboard: 2
};

const INSTANCE_TYPE_VALUE = {
  EMPTY: '',
  SCHEDULE_REPORT: 'Scheduled Reporting Item',
  SCHEDULE_ALERT: 'Scheduled Alert',
  SUBSCRIBE_REPORTING_ITEM: 'Subscribed Reporting Item',
  SUBSCRIBE_ALERT: 'Subscribed Alert'
};

export default {
  PAGE_SEARCH_SIZE: 10,
  LAST_SUCCESS_RUN_VALUE,
  DELIVERY_TYPE_VALUE,
  RECURRENCE_VALUE,
  INSTANCE_TYPE_VALUE,
  DELIVER_METHOD_VALUE,
  REPORT_TYPE_VALUE,
  VALIDATE_DATE_MESSAGE: 'To Date must be greater than or equal to From Date',
  TOOLTIP: {
    get EXPAND() {
      return localizer.getText('SCHEDULING_SEARCH_CONSTANT_TOOLTIP_EXPAND');
    },
    get COLLAPSE() {
      return localizer.getText('SCHEDULING_SEARCH_CONSTANT_TOOLTIP_COLLAPSE');
    }
  },
  DEFAULT_OPTION: {
    value: '',
    get label() {
      return localizer.getText('COMMON_LABEL_ALL');
    }
  },
  REPORT_TYPE: [
    {
      value: '',
      get label() {
        return localizer.getText('COMMON_LABEL_ALL');
      }
    },
    {
      value: 'Report',
      get label() {
        return localizer.getText('COMMON_LABEL_REPORTS');
      }
    },
    {
      value: 'Dashboard',
      get label() {
        return localizer.getText('COMMON_LABEL_DASHBOARD');
      }
    }
  ],
  INSTANCE_TYPE: [
    {
      value: '',
      get label() {
        return localizer.getText('COMMON_LABEL_ALL');
      }
    },
    {
      value: INSTANCE_TYPE_VALUE.SCHEDULE_REPORT,
      get label() {
        return localizer.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_INSTANCE_TYPE_SCHEDULE_REPORT');
      }
    },
    {
      value: INSTANCE_TYPE_VALUE.SCHEDULE_ALERT,
      get label() {
        return localizer.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_INSTANCE_TYPE_SCHEDULE_ALERT');
      },
      alertingLicense: true
    },
    {
      value: INSTANCE_TYPE_VALUE.SUBSCRIBE_REPORTING_ITEM,
      get label() {
        return localizer.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_INSTANCE_TYPE_SUBSCRIBE_REPORT');
      }
    },
    {
      value: INSTANCE_TYPE_VALUE.SUBSCRIBE_ALERT,
      get label() {
        return localizer.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_INSTANCE_TYPE_SUBSCRIBE_ALERT');
      },
      alertingLicense: true
    }
  ],
  RECURRENCE: [
    {
      value: RECURRENCE_VALUE.EMPTY,
      get label() {
        return localizer.getText('COMMON_LABEL_ALL');
      }
    },
    {
      value: RECURRENCE_VALUE.EVERY_DAY,
      get label() {
        return localizer.getText('COMMON_LABEL_EVERY_DATE');
      }
    },
    {
      value: RECURRENCE_VALUE.EVERY_WEEKDAY,
      get label() {
        return localizer.getText('COMMON_LABEL_EVERY_WEEKDAY');
      }
    },
    {
      value: RECURRENCE_VALUE.EVERY_WEEK,
      get label() {
        return localizer.getText('COMMON_LABEL_EVERY_WEEK');
      }
    },
    {
      value: RECURRENCE_VALUE.EVERY_TWO_WEEK,
      get label() {
        return localizer.getText('COMMON_LABEL_EVERY_TWO_WEEK');
      }
    },
    {
      value: RECURRENCE_VALUE.EVERY_MONTH,
      get label() {
        return localizer.getText('COMMON_LABEL_EVERY_MONTH');
      }
    },
    {
      value: RECURRENCE_VALUE.EVERY_QUARTER,
      get label() {
        return localizer.getText('COMMON_LABEL_EVERY_QUARTER');
      }
    },
    {
      value: RECURRENCE_VALUE.EVERY_HOURLY,
      get label() {
        return localizer.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_RECURRENCE_EVERY_HOURLY');
      }
    },
    {
      value: RECURRENCE_VALUE.EVERY_DAILY,
      get label() {
        return localizer.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_RECURRENCE_EVERY_DAILY');
      }
    },
    {
      value: RECURRENCE_VALUE.CUSTOM,
      get label() {
        return localizer.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_RECURRENCE_CUSTOM');
      }
    }
  ],
  DELIVERY_TYPE: [
    {
      value: DELIVERY_TYPE_VALUE.EMPTY,
      get label() {
        return localizer.getText('COMMON_LABEL_ALL');
      }
    },
    {
      value: DELIVERY_TYPE_VALUE.EMAIL,
      get label() {
        return localizer.getText('COMMON_LABEL_EMAIL');
      }
    },
    {
      value: DELIVERY_TYPE_VALUE.FILE_LOCATION,
      get label() {
        return localizer.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_DELIVERY_TYPE_FILE_LOCATION');
      }
    }
  ],
  DELIVERY_METHOD: [
    {
      value: DELIVER_METHOD_VALUE.EMPTY,
      get label() {
        return localizer.getText('COMMON_LABEL_ALL');
      }
    },
    {
      value: DELIVER_METHOD_VALUE.LINK,
      get label() {
        return localizer.getText('COMMON_LABEL_LINK');
      }
    },
    {
      value: DELIVER_METHOD_VALUE.ATTACHMENT,
      get label() {
        return localizer.getText('COMMON_LABEL_ATTACHMENT');
      }
    },
    {
      value: DELIVER_METHOD_VALUE.EMBEDDED_HTML,
      get label() {
        return localizer.getText('COMMON_LABEL_EMBEDDED_HTML');
      }
    },
    {
      value: DELIVER_METHOD_VALUE.SEND_TO_DISK,
      get label() {
        return localizer.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_DELIVERY_METHOD_SEND_TO_DISK');
      }
    }
  ],
  EXPORT_FILE_TYPE: [
    {
      value: '',
      get label() {
        return localizer.getText('COMMON_LABEL_ALL');
      }
    },
    { value: 'PDF', label: 'PDF' },
    { value: 'Word', label: 'Word' },
    { value: 'Excel', label: 'Excel' },
    { value: 'CSV', label: 'CSV' }
  ],
  LAST_SUCCESS_RUN: [
    {
      value: LAST_SUCCESS_RUN_VALUE.EMPTY,
      get label() {
        return localizer.getText('COMMON_LABEL_ALL');
      }
    },
    {
      value: LAST_SUCCESS_RUN_VALUE.DATE,
      get label() {
        return localizer.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_DATE');
      }
    },
    {
      value: LAST_SUCCESS_RUN_VALUE.CANNOT_BE_SEND,
      get label() {
        return localizer.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_LAST_SUCCESS_RUN_CANNOT_BE_SEND');
      }
    },
    {
      value: LAST_SUCCESS_RUN_VALUE.HAS_NOT_STATED,
      get label() {
        return localizer.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_LAST_SUCCESS_RUN_NOT_STARTED');
      }
    }
  ],
  NEXT_SCHEDULED_RUN: [
    {
      value: '',
      get label() {
        return localizer.getText('COMMON_LABEL_ALL');
      }
    },
    {
      value: 'date',
      get label() {
        return localizer.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_DATE');
      }
    },
    {
      value: 'No recurrence',
      get label() {
        return localizer.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_NEXT_SCHEDULED_RUN_NO_RECURRENCE');
      }
    },
    {
      value: 'The Schedule has ended',
      get label() {
        return localizer.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_NEXT_SCHEDULED_RUN_ENDED');
      }
    }
  ],
  SEARCH_KEY: {
    reportType: 'ReportingType',
    name: 'ReportDashboardName',
    deliveryType: 'DeliveryType',
    deliveryMethod: 'DeliveryMethod',
    recipients: 'Recipients',
    instanceType: 'Type',
    lastSuccessfulRun: 'LastSuccessfulRun',
    nextScheduledRun: 'NextScheduledRun',
    nextScheduledRunFrom: 'NextScheduledRunFrom',
    nextScheduledRunTo: 'NextScheduledRunTo',
    lastSuccessfulRunFrom: 'LastSuccessfulRunFrom',
    lastSuccessfulRunTo: 'LastSuccessfulRunTo',
    recurrence: 'RecurrenceType',
    exportFileType: 'ExportFileType',
    createdBy: 'CreatedBy'
  },
  TABLE_DEF: {
    selected: { key: 'selected', width: 30, title: '', sortable: false, columnKey: 'selected' },
    reportingType: {
      key: 'reportingType',
      width: 120,
      get title() {
        return localizer.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_REPORT_TYPE');
      },
      sortable: true,
      columnKey: 'reportingType'
    },
    reportDashboardName: {
      key: 'reportDashboardName',
      width: 140,
      get title() {
        return localizer.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_REPORTING_NAME');
      },
      sortable: true,
      columnKey: 'reportDashboardName'
    },
    name: {
      key: 'name',
      width: 140,
      get title() {
        return localizer.getText('COMMON_LABEL_INSTANCE_NAME');
      },
      sortable: true,
      columnKey: 'name'
    },
    type: {
      key: 'type',
      width: 100,
      get title() {
        return localizer.getText('COMMON_LABEL_TYPE');
      },
      sortable: true,
      columnKey: 'type'
    },
    schedule: {
      key: 'schedule',
      width: 220,
      get title() {
        return localizer.getText('COMMON_LABEL_SCHEDULE');
      },
      sortable: true,
      columnKey: 'schedule'
    },
    deliveryType: {
      key: 'deliveryType',
      width: 120,
      get title() {
        return localizer.getText('COMMON_LABEL_DELIVERY_TYPE');
      },
      sortable: true,
      columnKey: 'deliveryType'
    },
    deliveryMethod: {
      key: 'deliveryMethod',
      width: 140,
      get title() {
        return localizer.getText('COMMON_LABEL_DELIVERY_METHOD');
      },
      sortable: true,
      columnKey: 'deliveryMethod'
    },
    exportFileType: {
      key: 'exportFileType',
      width: 140,
      get title() {
        return localizer.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_EXPORT_FILE_TYPE');
      },
      sortable: true,
      columnKey: 'exportFileType'
    },
    recipients: {
      key: 'recipients',
      width: 120,
      get title() {
        return localizer.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_RECIPENT');
      },
      sortable: true,
      columnKey: 'recipients'
    },
    lastSuccessfulRun: {
      key: 'lastSuccessfulRun',
      width: 170,
      get title() {
        return localizer.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_LAST_SUCCESS_RUN');
      },
      sortable: true,
      columnKey: 'lastSuccessfulRun'
    },
    nextScheduledRun: {
      key: 'nextScheduledRun',
      width: 170,
      get title() {
        return localizer.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_NEXT_SCHEDULED_RUN');
      },
      sortable: true,
      columnKey: 'nextScheduledRun'
    },
    createdBy: {
      key: 'createdBy',
      width: 100,
      get title() {
        return localizer.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_CREATED_BY');
      },
      sortable: true,
      columnKey: 'createdBy'
    },
    action: {
      key: 'action',
      width: 80,
      get title() {
        return localizer.getText('COMMON_LABEL_ACTION');
      },
      sortable: false,
      fixed: true
    }
  },
  ACTION_TEXT: {
    get EditText() {
      return localizer.getText('SCHEDULING_SEARCH_CONSTANT_ACTION_EDIT_TEXT');
    },
    get DeleteText() {
      return localizer.getText('SCHEDULING_SEARCH_CONSTANT_ACTION_DELETE_TEXT');
    }
  },
  DEFAULT_SORT_ORDER: {
    name: 'DESC'
  },
  TEMPLATE_TYPE: 0
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.SchedulingSearchConstants.js